import { REDIRECT_AFTER_AUTH_PARAM } from '@components/App/Auth/VerifyEmail/constants'
import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export const useClearRedirectAfterAuth = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  return useCallback(() => {
    if (searchParams.has(REDIRECT_AFTER_AUTH_PARAM)) {
      searchParams.delete(REDIRECT_AFTER_AUTH_PARAM)
      setSearchParams(searchParams, { replace: true })
    }
  }, [searchParams, setSearchParams])
}
